import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Contests from "./pages/Contests";
import ContestDetail from "./pages/ContestDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import PaymentReturn from "./pages/PaymentReturn";
import Admin from "./pages/Admin";

const Loader = () => (
  <div className="flex min-h-[60vh] items-center justify-center" data-testid="page-loader">
    <div className="h-10 w-10 animate-spin rounded-full border-2 border-cyan-400 border-t-transparent" />
  </div>
);

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/entrar" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/painel" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="flex min-h-screen flex-col bg-[#0A0A0F]">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/galeria" element={<Gallery />} />
              <Route path="/concursos" element={<Contests />} />
              <Route path="/concursos/:id" element={<ContestDetail />} />
              <Route path="/entrar" element={<Login />} />
              <Route path="/cadastro" element={<Register />} />
              <Route path="/pagamento/retorno" element={<PaymentReturn />} />
              <Route path="/painel" element={<Protected><Dashboard /></Protected>} />
              <Route path="/proprietario" element={<Protected admin><Admin /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
